import { Tabs } from "antd";
import { useTranslation } from "react-i18next";
import OnDemandFilter from "Components/Report/OnDemand/Filter";
import ChartsList from "Components/Report/OnDemand/chartsList/ChartsList";
// import PeriodicFilter from "Components/Report/Periodic/Filter";
import PeriodicList from "Components/Report/Periodic/Reports";
import { useState } from "react";

const { TabPane } = Tabs;

const Report = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("ondemand");

  return (
    <Tabs type="card" activeKey={activeTab} onChange={setActiveTab}>
      <TabPane tab={t("ISMS.On-Demand")} key={"ondemand"}>
        <OnDemandFilter />
        <ChartsList />
      </TabPane>
      <TabPane tab={t("ISMS.Periodic")} key={"periodic"}>
        {/* <OnDemandFilter type={"static"} /> */}
        <PeriodicList isPeriodicActive={activeTab === "periodic"} />
      </TabPane>
    </Tabs>
  );
};

export default Report;
